import { ContentGrid } from './content-grid/ContentGrid';
import { ContentRichText } from './content-rich-text/ContentRichText';
import { ContentTestimonials } from './content-testimonials/ContentTestimonials';
import { ContentVideoCarousel } from './content-video-carousel/ContentVideoCarousel';
import { StaticComponent } from './static-component/StaticComponent';
import { ContentFaqList } from './content-faq-list/ContentFaqList';
import { ContentCaseStudies } from './content-case-studies/ContentCaseStudies';
import { ContentFloatingImageText } from './content-floating-image-text/ContentFloatingImageText';
import { ContentImageWithCaption } from './content-image-with-caption/content-image-with-caption';
import { ContentRelatedInsights } from './content-related-insights/ContentRelatedInsights';
import { ContentVideo } from './content-video/ContentVideo';

const constructSectionTemplate = templateItem => {
  const templateType = templateItem?.internal?.type;
  let templateInstance;

  switch (templateType) {
    case 'ContentfulSectionContentStaticComponent':
      templateInstance = new StaticComponent(templateItem);
      break;
    case 'ContentfulSectionContentGrid':
      templateInstance = new ContentGrid(templateItem);
      break;
    case 'ContentfulSectionContentTestimonials':
      templateInstance = new ContentTestimonials(templateItem);
      break;
    case 'ContentfulSectionContentRichTextBlockWithContactForm':
      templateInstance = new ContentRichText(templateItem);
      break;
    case 'ContentfulSectionContentVideoCarousel':
      templateInstance = new ContentVideoCarousel(templateItem);
      break;
    case 'ContentfulSectionContentFloatingImageText':
      templateInstance = new ContentFloatingImageText(templateItem);
      break;
    case 'ContentfulImageWithCaption':
      templateInstance = new ContentImageWithCaption(templateItem);
      break;
    case 'ContentfulSectionContentCaseStudies':
      templateInstance = new ContentCaseStudies(templateItem);
      break;
    case 'ContentfulFaqList':
      templateInstance = new ContentFaqList(templateItem);
      break;
    case 'ContentfulSectionContentRelatedInsights':
      templateInstance = new ContentRelatedInsights(templateItem);
      break;
    case 'ContentfulVideo':
      templateInstance = new ContentVideo(templateItem);
      break;
    default:
      templateInstance = new ContentGrid(templateItem);
      break;
  }

  return templateInstance;
};

export { constructSectionTemplate };
export * from './content-grid/ContentGrid';
export * from './content-rich-text/ContentRichText';
export * from './content-testimonials/ContentTestimonials';
export * from './static-component/StaticComponent';
export * from './content-video-carousel/ContentVideoCarousel';
export * from './content-case-studies/ContentCaseStudies';
